import "./price-range-filter";

const API_INPUT_SELECTOR = [
  "[data-api-filter-input]",
  "[data-price-bucket-input]",
  "[data-fabric-bucket-input]",
  "[data-delivery-time-input]",
].join(", ");

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();

    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    const facetForm = this.querySelector("form");

    if (!facetForm) return;

    facetForm.addEventListener("input", (event) => {

      if (event.target.matches(API_INPUT_SELECTOR)) return;

      this.handleNativeFormChange(event);
    });

    facetForm.addEventListener("aria-listbox:change", (event) => {
      this.handleNativeFormChange(event);
    });
  }

  createSearchParams(form) {
    return new URLSearchParams(new FormData(form));
  }

  handleNativeFormChange(event) {
    event.preventDefault?.();

    const forms = document.querySelectorAll("facet-filters-form form");
    const next = new URLSearchParams(window.location.search);

    forms.forEach((form) => {
      this.createSearchParams(form).forEach((value, key) => {
        if (!key) return;

        next.delete(key);

        if (value) next.append(key, value);
      });
    });

    next.delete("page");
    next.delete("grouped_page");

    const query = next.toString();
    const url = `${window.location.pathname}${query ? `?${query}` : ""}${window.location.hash}`;

    window.location.assign(url);
  }

  onActiveFilterClick(event) {
    event.preventDefault();

    const href = event.currentTarget?.href;

    if (href) window.location.assign(href);
  }
}

if (!customElements.get("facet-filters-form")) {
  customElements.define("facet-filters-form", FacetFiltersForm);
}

class PriceRange extends HTMLElement {
  constructor() {
    super();

    this.querySelectorAll("input").forEach((element) =>
      element.addEventListener("change", this.onRangeChange.bind(this)),
    );

    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll("input");
    const minInput = inputs[0];
    const maxInput = inputs[1];

    if (!minInput || !maxInput) return;

    if (maxInput.value) minInput.setAttribute("max", maxInput.value);
    if (minInput.value) maxInput.setAttribute("min", minInput.value);
    if (minInput.value === "") maxInput.setAttribute("min", 0);
    if (maxInput.value === "") minInput.setAttribute("max", maxInput.getAttribute("max"));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute("min"));
    const max = Number(input.getAttribute("max"));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

if (!customElements.get("price-range")) {
  customElements.define("price-range", PriceRange);
}

class FacetRemove extends HTMLElement {
  constructor() {
    super();

    const facetLink = this.querySelector("a");

    if (!facetLink) return;

    facetLink.setAttribute("role", "button");
    facetLink.addEventListener("click", this.closeFilter.bind(this));
    facetLink.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "SPACE") this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();

    const href = event.currentTarget?.href;

    if (href) window.location.assign(href);
  }
}

if (!customElements.get("facet-remove")) {
  customElements.define("facet-remove", FacetRemove);
}
